import { forwardRef, memo, useMemo } from 'react';
import Color from 'color';
import { Mesh } from 'three';

import { Grid, GridProps } from '@spazious/dollhouse-engine';
import { useStore } from '@spazious/dollhouse-store';

/**
 * Grid component with styled colors based on the current theme
 */
export const StyledGrid = memo(
  forwardRef<Mesh, GridProps>((props, fowardedRef) => {
    const theme = useStore(({ theme }) => theme);
    const showGrid = useStore(({ settings }) => settings.showGrid);

    const showGridPros = !showGrid ? { cellSize: 0, sectionSize: 0 } : {};

    const finalColor = useMemo(() => {
      return (theme === 'light' ? new Color('#b3b3b3') : new Color('#454545')).hex();
    }, [theme]);

    return (
      <Grid
        ref={fowardedRef}
        cellColor={finalColor}
        sectionColor={finalColor}
        {...showGridPros}
        {...props}
      />
    );
  })
);
